import { waitForLocationId, waitForStoreIds } from '@/util/storeHelpers'

type WaitType = 'locationId' | 'groupId' | 'none'

export function withStoreDependencies(waitType: WaitType = 'locationId') {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value

    descriptor.value = async function (...args: any[]) {
      switch (waitType) {
        case 'locationId':
          await waitForLocationId()
          break
        case 'groupId':
          await waitForStoreIds()
          break
        case 'none':
          break
      }
      return originalMethod.apply(this, args)
    }

    return descriptor
  }
}

export function ServiceWithStoreDependencies(
  waitType: WaitType = 'locationId'
) {
  return function <T extends { prototype: any }>(constructor: T): T {
    const methodNames = Object.getOwnPropertyNames(
      constructor.prototype
    ).filter(name => {
      if (name === 'constructor') return false
      const descriptor = Object.getOwnPropertyDescriptor(
        constructor.prototype,
        name
      )
      return (
        descriptor &&
        typeof descriptor.value === 'function' &&
        descriptor.value.constructor.name === 'AsyncFunction'
      )
    })

    methodNames.forEach(methodName => {
      const descriptor = Object.getOwnPropertyDescriptor(
        constructor.prototype,
        methodName
      )
      if (descriptor && typeof descriptor.value === 'function') {
        Object.defineProperty(
          constructor.prototype,
          methodName,
          withStoreDependencies(waitType)(
            constructor.prototype,
            methodName,
            descriptor
          )
        )
      }
    })

    return constructor
  }
}
